// @generated by protobuf-ts 2.11.1 with parameter long_type_string,generate_dependencies,output_legacy_commonjs
// @generated from protobuf file "sennotech/base/account/mobile_account.proto" (package "base.account", syntax proto3)
// tslint:disable
import { ResetPasswordResponse } from "./account";
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { BoolValue } from "../../google/protobuf/wrappers";
import { StringValue } from "../../google/protobuf/wrappers";
/**
 * @generated from protobuf message base.account.CheckPasswordExistByClientResponse
 */
export interface CheckPasswordExistByClientResponse {
    /**
     * @generated from protobuf field: bool exist = 1
     */
    exist: boolean;
}
/**
 * @generated from protobuf message base.account.CheckPasswordExistByClientRequest
 */
export interface CheckPasswordExistByClientRequest {
    /**
     * @generated from protobuf field: string countryCode = 1
     */
    countryCode: string;
    /**
     * @generated from protobuf field: string mobileNumber = 2
     */
    mobileNumber: string;
    /**
     * @generated from protobuf field: google.protobuf.StringValue client = 3
     */
    client?: StringValue;
}
/**
 * @generated from protobuf message base.account.ActivateAccountByMobileNumberAndCaptchaResponse
 */
export interface ActivateAccountByMobileNumberAndCaptchaResponse {
    /**
     * @generated from protobuf field: bool done = 1
     */
    done: boolean;
}
/**
 * @generated from protobuf message base.account.ActivateAccountByMobileNumberAndCaptchaRequest
 */
export interface ActivateAccountByMobileNumberAndCaptchaRequest {
    /**
     * @generated from protobuf field: string countryCode = 1
     */
    countryCode: string;
    /**
     * @generated from protobuf field: string mobileNumber = 2
     */
    mobileNumber: string;
    /**
     * @generated from protobuf field: string captcha = 3
     */
    captcha: string;
}
/**
 * @generated from protobuf message base.account.ResetMobileAccountPasswordByTokenRequest
 */
export interface ResetMobileAccountPasswordByTokenRequest {
    /**
     * @generated from protobuf field: string password = 2
     */
    password: string;
}
/**
 * @generated from protobuf message base.account.ResetMobileAccountPasswordByOriginalPasswordRequest
 */
export interface ResetMobileAccountPasswordByOriginalPasswordRequest {
    /**
     * @generated from protobuf field: int64 accountId = 1
     */
    accountId: string; // 若不传则从accessToken中获取
    /**
     * @generated from protobuf field: string originalPassword = 2
     */
    originalPassword: string; // 原密码
    /**
     * @generated from protobuf field: string newPassword = 3
     */
    newPassword: string; // 新密码
}
/**
 * @generated from protobuf message base.account.ResetMobileAccountPasswordRequest
 */
export interface ResetMobileAccountPasswordRequest {
    /**
     * @generated from protobuf field: int64 accountId = 1
     */
    accountId: string;
    /**
     * @generated from protobuf field: string password = 2
     */
    password: string;
}
/**
 * @generated from protobuf message base.account.GetMobileNumberPageByAppIdRequest
 */
export interface GetMobileNumberPageByAppIdRequest {
    /**
     * @generated from protobuf field: string appId = 1
     */
    appId: string;
    /**
     * @generated from protobuf field: int32 pageNum = 2
     */
    pageNum: number;
    /**
     * @generated from protobuf field: int32 pageSize = 3
     */
    pageSize: number;
}
/**
 * @generated from protobuf message base.account.GetMobileNumberPageByAppIdResponse
 */
export interface GetMobileNumberPageByAppIdResponse {
    /**
     * @generated from protobuf field: repeated base.account.GetMobileNumberByAccountsResponse.MobileNumberByAccountResult result = 1
     */
    result: GetMobileNumberByAccountsResponse_MobileNumberByAccountResult[];
    /**
     * @generated from protobuf field: int64 totalElements = 2
     */
    totalElements: string;
    /**
     * @generated from protobuf field: int32 totalPages = 3
     */
    totalPages: number;
    /**
     * @generated from protobuf field: bool isFirst = 4
     */
    isFirst: boolean;
    /**
     * @generated from protobuf field: bool isLast = 5
     */
    isLast: boolean;
    /**
     * @generated from protobuf field: int32 number = 6
     */
    number: number;
    /**
     * @generated from protobuf field: int32 numberOfElements = 7
     */
    numberOfElements: number;
    /**
     * @generated from protobuf field: int32 size = 8
     */
    size: number;
}
/**
 * @generated from protobuf message base.account.GetMobileNumberPageByAccountsRequest
 */
export interface GetMobileNumberPageByAccountsRequest {
    /**
     * @generated from protobuf field: repeated int64 accountIds = 1
     */
    accountIds: string[];
    /**
     * @generated from protobuf field: int32 pageNum = 2
     */
    pageNum: number;
    /**
     * @generated from protobuf field: int32 pageSize = 3
     */
    pageSize: number;
}
/**
 * @generated from protobuf message base.account.GetMobileNumberPageByAccountsResponse
 */
export interface GetMobileNumberPageByAccountsResponse {
    /**
     * @generated from protobuf field: repeated base.account.GetMobileNumberByAccountsResponse.MobileNumberByAccountResult result = 1
     */
    result: GetMobileNumberByAccountsResponse_MobileNumberByAccountResult[];
    /**
     * @generated from protobuf field: int64 totalElements = 2
     */
    totalElements: string;
    /**
     * @generated from protobuf field: int32 totalPages = 3
     */
    totalPages: number;
    /**
     * @generated from protobuf field: bool isFirst = 4
     */
    isFirst: boolean;
    /**
     * @generated from protobuf field: bool isLast = 5
     */
    isLast: boolean;
    /**
     * @generated from protobuf field: int32 number = 6
     */
    number: number;
    /**
     * @generated from protobuf field: int32 numberOfElements = 7
     */
    numberOfElements: number;
    /**
     * @generated from protobuf field: int32 size = 8
     */
    size: number;
}
/**
 * @generated from protobuf message base.account.GetByCreateTimestampBetweenRequest
 */
export interface GetByCreateTimestampBetweenRequest {
    /**
     * @generated from protobuf field: int64 startTimestamp = 1
     */
    startTimestamp: string;
    /**
     * @generated from protobuf field: int64 endTimestamp = 2
     */
    endTimestamp: string;
}
/**
 * @generated from protobuf message base.account.GetByCreateTimestampBetweenResponse
 */
export interface GetByCreateTimestampBetweenResponse {
    /**
     * @generated from protobuf field: repeated int64 accountIds = 1
     */
    accountIds: string[];
}
/**
 * @generated from protobuf message base.account.GetByMobileNumberContainsRequest
 */
export interface GetByMobileNumberContainsRequest {
    /**
     * @generated from protobuf field: string mobileNumber = 1
     */
    mobileNumber: string;
}
/**
 * @generated from protobuf message base.account.GetByMobileNumberContainsResponse
 */
export interface GetByMobileNumberContainsResponse {
    /**
     * @generated from protobuf field: repeated int64 accountIds = 1
     */
    accountIds: string[];
}
/**
 * @generated from protobuf message base.account.GetCreationTimestampByAccountIdsRequest
 */
export interface GetCreationTimestampByAccountIdsRequest {
    /**
     * @generated from protobuf field: repeated int64 accountIds = 1
     */
    accountIds: string[];
}
/**
 * @generated from protobuf message base.account.GetCreationTimestampByAccountIdsResponse
 */
export interface GetCreationTimestampByAccountIdsResponse {
    /**
     * @generated from protobuf field: repeated base.account.CreationTimestampByAccountIds account = 1
     */
    account: CreationTimestampByAccountIds[];
}
/**
 * @generated from protobuf message base.account.CreationTimestampByAccountIds
 */
export interface CreationTimestampByAccountIds {
    /**
     * @generated from protobuf field: int64 accountId = 1
     */
    accountId: string;
    /**
     * @generated from protobuf field: int64 creationTimestamp = 2
     */
    creationTimestamp: string;
}
/**
 * @generated from protobuf message base.account.BindingAccountIdForMobileNumberRequest
 */
export interface BindingAccountIdForMobileNumberRequest {
    /**
     * @generated from protobuf field: string mobileNumber = 1
     */
    mobileNumber: string;
    /**
     * @generated from protobuf field: string countryCode = 2
     */
    countryCode: string;
}
/**
 * @generated from protobuf message base.account.BindingAccountIdForMobileNumberResponse
 */
export interface BindingAccountIdForMobileNumberResponse {
    /**
     * @generated from protobuf field: int64 mobileAccountId = 1
     */
    mobileAccountId: string;
}
/**
 * @generated from protobuf message base.account.CheckMobileNumberExistenceRequest
 */
export interface CheckMobileNumberExistenceRequest {
}
/**
 * @generated from protobuf message base.account.CheckMobileNumberExistenceResponse
 */
export interface CheckMobileNumberExistenceResponse {
    /**
     * @generated from protobuf field: bool isExisted = 1
     */
    isExisted: boolean;
}
/**
 * @generated from protobuf message base.account.GetMobileNumberByAccountsRequest
 */
export interface GetMobileNumberByAccountsRequest {
    /**
     * @generated from protobuf field: repeated int64 accountIds = 1
     */
    accountIds: string[];
}
/**
 * @generated from protobuf message base.account.GetMobileNumberByAccountsResponse
 */
export interface GetMobileNumberByAccountsResponse {
    /**
     * @generated from protobuf field: repeated base.account.GetMobileNumberByAccountsResponse.MobileNumberByAccountResult result = 1
     */
    result: GetMobileNumberByAccountsResponse_MobileNumberByAccountResult[];
}
/**
 * @generated from protobuf message base.account.GetMobileNumberByAccountsResponse.MobileNumberByAccountResult
 */
export interface GetMobileNumberByAccountsResponse_MobileNumberByAccountResult {
    /**
     * @generated from protobuf field: int64 accountId = 1
     */
    accountId: string;
    /**
     * @generated from protobuf field: string mobileNumber = 2
     */
    mobileNumber: string;
    /**
     * @generated from protobuf field: int64 timestamp = 3
     */
    timestamp: string;
}
/**
 * @generated from protobuf message base.account.RegisterByPasswordRequest
 */
export interface RegisterByPasswordRequest {
    /**
     * @generated from protobuf field: string countryCode = 1
     */
    countryCode: string;
    /**
     * @generated from protobuf field: string mobileNumber = 2
     */
    mobileNumber: string;
    /**
     * @generated from protobuf field: google.protobuf.StringValue captcha = 3
     */
    captcha?: StringValue;
    /**
     * @generated from protobuf field: google.protobuf.StringValue password = 4
     */
    password?: StringValue;
    /**
     * @generated from protobuf field: google.protobuf.StringValue client = 5
     */
    client?: StringValue;
    /**
     * @generated from protobuf field: google.protobuf.BoolValue activated = 6
     */
    activated?: BoolValue;
}
/**
 * @generated from protobuf message base.account.SetPasswordForMobileRequest
 */
export interface SetPasswordForMobileRequest {
    /**
     * @generated from protobuf field: string countryCode = 1
     */
    countryCode: string;
    /**
     * @generated from protobuf field: string mobileNumber = 2
     */
    mobileNumber: string;
    /**
     * @generated from protobuf field: google.protobuf.StringValue captcha = 3
     */
    captcha?: StringValue;
    /**
     * @generated from protobuf field: google.protobuf.StringValue password = 4
     */
    password?: StringValue;
}
/**
 * @generated from protobuf message base.account.SetPasswordForMobileResponse
 */
export interface SetPasswordForMobileResponse {
    /**
     * @generated from protobuf field: bool isSuccess = 1
     */
    isSuccess: boolean;
}
/**
 * @generated from protobuf message base.account.RegisterByPasswordResponse
 */
export interface RegisterByPasswordResponse {
    /**
     * @generated from protobuf field: string accessToken = 1
     */
    accessToken: string;
    /**
     * @generated from protobuf field: int64 accountId = 2
     */
    accountId: string;
    /**
     * @generated from protobuf field: int64 expiresTimestamp = 3
     */
    expiresTimestamp: string;
    /**
     * @generated from protobuf field: bool activated = 4
     */
    activated: boolean;
    /**
     * @generated from protobuf field: string refreshToken = 5
     */
    refreshToken: string; // 刷新的token，有效期30天
    /**
     * @generated from protobuf field: int64 expiresIn = 6
     */
    expiresIn: string; // 在...时间（毫秒）内到期
}
/**
 * @generated from protobuf message base.account.RegisterByCaptchaRequest
 */
export interface RegisterByCaptchaRequest {
    /**
     * @generated from protobuf field: string countryCode = 1
     */
    countryCode: string;
    /**
     * @generated from protobuf field: string mobileNumber = 2
     */
    mobileNumber: string;
    /**
     * @generated from protobuf field: string captcha = 3
     */
    captcha: string;
    /**
     * @generated from protobuf field: google.protobuf.StringValue client = 4
     */
    client?: StringValue;
}
/**
 * @generated from protobuf message base.account.RegisterByCaptchaResponse
 */
export interface RegisterByCaptchaResponse {
    /**
     * @generated from protobuf field: string accessToken = 1
     */
    accessToken: string;
    /**
     * @generated from protobuf field: int64 accountId = 2
     */
    accountId: string;
    /**
     * @generated from protobuf field: int64 expiresTimestamp = 3
     */
    expiresTimestamp: string;
    /**
     * @generated from protobuf field: bool activated = 4
     */
    activated: boolean;
    /**
     * @generated from protobuf field: string refreshToken = 5
     */
    refreshToken: string; // 刷新的token，有效期30天
    /**
     * @generated from protobuf field: int64 expiresIn = 6
     */
    expiresIn: string; // 在...时间（毫秒）内到期
}
// message RegisterByCaptcha {
//    string accessToken = 1;
//    string mobileNumber = 2;
// }

/**
 * @generated from protobuf message base.account.RegisterRequest
 */
export interface RegisterRequest {
    /**
     * @generated from protobuf field: string countryCode = 1
     */
    countryCode: string;
    /**
     * @generated from protobuf field: string mobileNumber = 2
     */
    mobileNumber: string;
    /**
     * @generated from protobuf field: google.protobuf.StringValue client = 4
     */
    client?: StringValue;
    /**
     * @generated from protobuf field: google.protobuf.BoolValue activated = 5
     */
    activated?: BoolValue;
}
/**
 * @generated from protobuf message base.account.RegisterResponse
 */
export interface RegisterResponse {
    /**
     * @generated from protobuf field: int64 accountId = 1
     */
    accountId: string;
    /**
     * @generated from protobuf field: string accessToken = 2
     */
    accessToken: string;
    /**
     * @generated from protobuf field: int64 expiresTimestamp = 3
     */
    expiresTimestamp: string;
    /**
     * @generated from protobuf field: bool activated = 4
     */
    activated: boolean;
    /**
     * @generated from protobuf field: string refreshToken = 5
     */
    refreshToken: string; // 刷新的token，有效期30天
    /**
     * @generated from protobuf field: int64 expiresIn = 6
     */
    expiresIn: string; // 在...时间（毫秒）内到期
}
/**
 * @generated from protobuf message base.account.GetAccountIdRequest
 */
export interface GetAccountIdRequest {
    /**
     * @generated from protobuf field: string countryCode = 1
     */
    countryCode: string;
    /**
     * @generated from protobuf field: string mobileNumber = 2
     */
    mobileNumber: string;
}
/**
 * @generated from protobuf message base.account.GetAccountIdResponse
 */
export interface GetAccountIdResponse {
    /**
     * @generated from protobuf field: int64 accountId = 1
     */
    accountId: string;
}
// message Register {
//    string accessToken = 1;
//    string mobileNumber = 2;
// }

/**
 * @generated from protobuf message base.account.IsRegisteredRequest
 */
export interface IsRegisteredRequest {
    /**
     * @generated from protobuf field: string countryCode = 1
     */
    countryCode: string;
    /**
     * @generated from protobuf field: string mobileNumber = 2
     */
    mobileNumber: string;
}
/**
 * @generated from protobuf message base.account.IsRegisteredResponse
 */
export interface IsRegisteredResponse {
    /**
     * @generated from protobuf field: bool isRegistered = 1
     */
    isRegistered: boolean;
    /**
     * @generated from protobuf field: bool activated = 2
     */
    activated: boolean;
}
/**
 * @generated from protobuf message base.account.LoginByPasswordRequest
 */
export interface LoginByPasswordRequest {
    /**
     * @generated from protobuf field: string countryCode = 1
     */
    countryCode: string;
    /**
     * @generated from protobuf field: string mobileNumber = 2
     */
    mobileNumber: string;
    /**
     * @generated from protobuf field: string password = 3
     */
    password: string;
    /**
     * @generated from protobuf field: google.protobuf.StringValue client = 4
     */
    client?: StringValue;
}
/**
 * @generated from protobuf message base.account.LoginByPasswordResponse
 */
export interface LoginByPasswordResponse {
    /**
     * @generated from protobuf field: string accessToken = 1
     */
    accessToken: string;
    /**
     * @generated from protobuf field: bool activated = 2
     */
    activated: boolean;
    /**
     * @generated from protobuf field: int64 accountId = 3
     */
    accountId: string;
    /**
     * @generated from protobuf field: int64 expiresTimestamp = 4
     */
    expiresTimestamp: string;
    /**
     * @generated from protobuf field: string refreshToken = 5
     */
    refreshToken: string; // 刷新的token，有效期30天
    /**
     * @generated from protobuf field: int64 expiresIn = 6
     */
    expiresIn: string; // 在...时间（毫秒）内到期
}
/**
 * @generated from protobuf message base.account.LoginByCaptchaRequest
 */
export interface LoginByCaptchaRequest {
    /**
     * @generated from protobuf field: string countryCode = 1
     */
    countryCode: string;
    /**
     * @generated from protobuf field: string mobileNumber = 2
     */
    mobileNumber: string;
    /**
     * @generated from protobuf field: string captcha = 3
     */
    captcha: string;
    /**
     * @generated from protobuf field: google.protobuf.StringValue client = 4
     */
    client?: StringValue;
}
/**
 * @generated from protobuf message base.account.LoginByCaptchaResponse
 */
export interface LoginByCaptchaResponse {
    /**
     * @generated from protobuf field: string accessToken = 1
     */
    accessToken: string;
    /**
     * @generated from protobuf field: int64 accountId = 3
     */
    accountId: string;
    /**
     * @generated from protobuf field: int64 expiresTimestamp = 4
     */
    expiresTimestamp: string;
    /**
     * @generated from protobuf field: string refreshToken = 5
     */
    refreshToken: string; // 刷新的token，有效期30天
    /**
     * @generated from protobuf field: int64 expiresIn = 6
     */
    expiresIn: string; // 在...时间（毫秒）内到期
}
// @generated message type with reflection information, may provide speed optimized methods
class CheckPasswordExistByClientResponse$Type extends MessageType<CheckPasswordExistByClientResponse> {
    constructor() {
        super("base.account.CheckPasswordExistByClientResponse", [
            { no: 1, name: "exist", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<CheckPasswordExistByClientResponse>): CheckPasswordExistByClientResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.exist = false;
        if (value !== undefined)
            reflectionMergePartial<CheckPasswordExistByClientResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CheckPasswordExistByClientResponse): CheckPasswordExistByClientResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool exist */ 1:
                    message.exist = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CheckPasswordExistByClientResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool exist = 1; */
        if (message.exist !== false)
            writer.tag(1, WireType.Varint).bool(message.exist);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.account.CheckPasswordExistByClientResponse
 */
export const CheckPasswordExistByClientResponse = new CheckPasswordExistByClientResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CheckPasswordExistByClientRequest$Type extends MessageType<CheckPasswordExistByClientRequest> {
    constructor() {
        super("base.account.CheckPasswordExistByClientRequest", [
            { no: 1, name: "countryCode", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "mobileNumber", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "client", kind: "message", T: () => StringValue }
        ]);
    }
    create(value?: PartialMessage<CheckPasswordExistByClientRequest>): CheckPasswordExistByClientRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.countryCode = "";
        message.mobileNumber = "";
        if (value !== undefined)
            reflectionMergePartial<CheckPasswordExistByClientRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CheckPasswordExistByClientRequest): CheckPasswordExistByClientRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string countryCode */ 1:
                    message.countryCode = reader.string();
                    break;
                case /* string mobileNumber */ 2:
                    message.mobileNumber = reader.string();
                    break;
                case /* google.protobuf.StringValue client */ 3:
                    message.client = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.client);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CheckPasswordExistByClientRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string countryCode = 1; */
        if (message.countryCode !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.countryCode);
        /* string mobileNumber = 2; */
        if (message.mobileNumber !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.mobileNumber);
        /* google.protobuf.StringValue client = 3; */
        if (message.client)
            StringValue.internalBinaryWrite(message.client, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.account.CheckPasswordExistByClientRequest
 */
export const CheckPasswordExistByClientRequest = new CheckPasswordExistByClientRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ActivateAccountByMobileNumberAndCaptchaResponse$Type extends MessageType<ActivateAccountByMobileNumberAndCaptchaResponse> {
    constructor() {
        super("base.account.ActivateAccountByMobileNumberAndCaptchaResponse", [
            { no: 1, name: "done", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<ActivateAccountByMobileNumberAndCaptchaResponse>): ActivateAccountByMobileNumberAndCaptchaResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.done = false;
        if (value !== undefined)
            reflectionMergePartial<ActivateAccountByMobileNumberAndCaptchaResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ActivateAccountByMobileNumberAndCaptchaResponse): ActivateAccountByMobileNumberAndCaptchaResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool done */ 1:
                    message.done = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ActivateAccountByMobileNumberAndCaptchaResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool done = 1; */
        if (message.done !== false)
            writer.tag(1, WireType.Varint).bool(message.done);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.account.ActivateAccountByMobileNumberAndCaptchaResponse
 */
export const ActivateAccountByMobileNumberAndCaptchaResponse = new ActivateAccountByMobileNumberAndCaptchaResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ActivateAccountByMobileNumberAndCaptchaRequest$Type extends MessageType<ActivateAccountByMobileNumberAndCaptchaRequest> {
    constructor() {
        super("base.account.ActivateAccountByMobileNumberAndCaptchaRequest", [
            { no: 1, name: "countryCode", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "mobileNumber", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "captcha", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ActivateAccountByMobileNumberAndCaptchaRequest>): ActivateAccountByMobileNumberAndCaptchaRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.countryCode = "";
        message.mobileNumber = "";
        message.captcha = "";
        if (value !== undefined)
            reflectionMergePartial<ActivateAccountByMobileNumberAndCaptchaRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ActivateAccountByMobileNumberAndCaptchaRequest): ActivateAccountByMobileNumberAndCaptchaRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string countryCode */ 1:
                    message.countryCode = reader.string();
                    break;
                case /* string mobileNumber */ 2:
                    message.mobileNumber = reader.string();
                    break;
                case /* string captcha */ 3:
                    message.captcha = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ActivateAccountByMobileNumberAndCaptchaRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string countryCode = 1; */
        if (message.countryCode !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.countryCode);
        /* string mobileNumber = 2; */
        if (message.mobileNumber !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.mobileNumber);
        /* string captcha = 3; */
        if (message.captcha !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.captcha);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.account.ActivateAccountByMobileNumberAndCaptchaRequest
 */
export const ActivateAccountByMobileNumberAndCaptchaRequest = new ActivateAccountByMobileNumberAndCaptchaRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ResetMobileAccountPasswordByTokenRequest$Type extends MessageType<ResetMobileAccountPasswordByTokenRequest> {
    constructor() {
        super("base.account.ResetMobileAccountPasswordByTokenRequest", [
            { no: 2, name: "password", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ResetMobileAccountPasswordByTokenRequest>): ResetMobileAccountPasswordByTokenRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.password = "";
        if (value !== undefined)
            reflectionMergePartial<ResetMobileAccountPasswordByTokenRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ResetMobileAccountPasswordByTokenRequest): ResetMobileAccountPasswordByTokenRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string password */ 2:
                    message.password = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ResetMobileAccountPasswordByTokenRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string password = 2; */
        if (message.password !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.password);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.account.ResetMobileAccountPasswordByTokenRequest
 */
export const ResetMobileAccountPasswordByTokenRequest = new ResetMobileAccountPasswordByTokenRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ResetMobileAccountPasswordByOriginalPasswordRequest$Type extends MessageType<ResetMobileAccountPasswordByOriginalPasswordRequest> {
    constructor() {
        super("base.account.ResetMobileAccountPasswordByOriginalPasswordRequest", [
            { no: 1, name: "accountId", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 2, name: "originalPassword", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "newPassword", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ResetMobileAccountPasswordByOriginalPasswordRequest>): ResetMobileAccountPasswordByOriginalPasswordRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accountId = "0";
        message.originalPassword = "";
        message.newPassword = "";
        if (value !== undefined)
            reflectionMergePartial<ResetMobileAccountPasswordByOriginalPasswordRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ResetMobileAccountPasswordByOriginalPasswordRequest): ResetMobileAccountPasswordByOriginalPasswordRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 accountId */ 1:
                    message.accountId = reader.int64().toString();
                    break;
                case /* string originalPassword */ 2:
                    message.originalPassword = reader.string();
                    break;
                case /* string newPassword */ 3:
                    message.newPassword = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ResetMobileAccountPasswordByOriginalPasswordRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 accountId = 1; */
        if (message.accountId !== "0")
            writer.tag(1, WireType.Varint).int64(message.accountId);
        /* string originalPassword = 2; */
        if (message.originalPassword !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.originalPassword);
        /* string newPassword = 3; */
        if (message.newPassword !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.newPassword);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.account.ResetMobileAccountPasswordByOriginalPasswordRequest
 */
export const ResetMobileAccountPasswordByOriginalPasswordRequest = new ResetMobileAccountPasswordByOriginalPasswordRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ResetMobileAccountPasswordRequest$Type extends MessageType<ResetMobileAccountPasswordRequest> {
    constructor() {
        super("base.account.ResetMobileAccountPasswordRequest", [
            { no: 1, name: "accountId", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 2, name: "password", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ResetMobileAccountPasswordRequest>): ResetMobileAccountPasswordRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accountId = "0";
        message.password = "";
        if (value !== undefined)
            reflectionMergePartial<ResetMobileAccountPasswordRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ResetMobileAccountPasswordRequest): ResetMobileAccountPasswordRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 accountId */ 1:
                    message.accountId = reader.int64().toString();
                    break;
                case /* string password */ 2:
                    message.password = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ResetMobileAccountPasswordRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 accountId = 1; */
        if (message.accountId !== "0")
            writer.tag(1, WireType.Varint).int64(message.accountId);
        /* string password = 2; */
        if (message.password !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.password);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.account.ResetMobileAccountPasswordRequest
 */
export const ResetMobileAccountPasswordRequest = new ResetMobileAccountPasswordRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetMobileNumberPageByAppIdRequest$Type extends MessageType<GetMobileNumberPageByAppIdRequest> {
    constructor() {
        super("base.account.GetMobileNumberPageByAppIdRequest", [
            { no: 1, name: "appId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "pageNum", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "pageSize", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<GetMobileNumberPageByAppIdRequest>): GetMobileNumberPageByAppIdRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.pageNum = 0;
        message.pageSize = 0;
        if (value !== undefined)
            reflectionMergePartial<GetMobileNumberPageByAppIdRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetMobileNumberPageByAppIdRequest): GetMobileNumberPageByAppIdRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string appId */ 1:
                    message.appId = reader.string();
                    break;
                case /* int32 pageNum */ 2:
                    message.pageNum = reader.int32();
                    break;
                case /* int32 pageSize */ 3:
                    message.pageSize = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetMobileNumberPageByAppIdRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string appId = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* int32 pageNum = 2; */
        if (message.pageNum !== 0)
            writer.tag(2, WireType.Varint).int32(message.pageNum);
        /* int32 pageSize = 3; */
        if (message.pageSize !== 0)
            writer.tag(3, WireType.Varint).int32(message.pageSize);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.account.GetMobileNumberPageByAppIdRequest
 */
export const GetMobileNumberPageByAppIdRequest = new GetMobileNumberPageByAppIdRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetMobileNumberPageByAppIdResponse$Type extends MessageType<GetMobileNumberPageByAppIdResponse> {
    constructor() {
        super("base.account.GetMobileNumberPageByAppIdResponse", [
            { no: 1, name: "result", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => GetMobileNumberByAccountsResponse_MobileNumberByAccountResult },
            { no: 2, name: "totalElements", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 3, name: "totalPages", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "isFirst", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "isLast", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "numberOfElements", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 8, name: "size", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<GetMobileNumberPageByAppIdResponse>): GetMobileNumberPageByAppIdResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.result = [];
        message.totalElements = "0";
        message.totalPages = 0;
        message.isFirst = false;
        message.isLast = false;
        message.number = 0;
        message.numberOfElements = 0;
        message.size = 0;
        if (value !== undefined)
            reflectionMergePartial<GetMobileNumberPageByAppIdResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetMobileNumberPageByAppIdResponse): GetMobileNumberPageByAppIdResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated base.account.GetMobileNumberByAccountsResponse.MobileNumberByAccountResult result */ 1:
                    message.result.push(GetMobileNumberByAccountsResponse_MobileNumberByAccountResult.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int64 totalElements */ 2:
                    message.totalElements = reader.int64().toString();
                    break;
                case /* int32 totalPages */ 3:
                    message.totalPages = reader.int32();
                    break;
                case /* bool isFirst */ 4:
                    message.isFirst = reader.bool();
                    break;
                case /* bool isLast */ 5:
                    message.isLast = reader.bool();
                    break;
                case /* int32 number */ 6:
                    message.number = reader.int32();
                    break;
                case /* int32 numberOfElements */ 7:
                    message.numberOfElements = reader.int32();
                    break;
                case /* int32 size */ 8:
                    message.size = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetMobileNumberPageByAppIdResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated base.account.GetMobileNumberByAccountsResponse.MobileNumberByAccountResult result = 1; */
        for (let i = 0; i < message.result.length; i++)
            GetMobileNumberByAccountsResponse_MobileNumberByAccountResult.internalBinaryWrite(message.result[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int64 totalElements = 2; */
        if (message.totalElements !== "0")
            writer.tag(2, WireType.Varint).int64(message.totalElements);
        /* int32 totalPages = 3; */
        if (message.totalPages !== 0)
            writer.tag(3, WireType.Varint).int32(message.totalPages);
        /* bool isFirst = 4; */
        if (message.isFirst !== false)
            writer.tag(4, WireType.Varint).bool(message.isFirst);
        /* bool isLast = 5; */
        if (message.isLast !== false)
            writer.tag(5, WireType.Varint).bool(message.isLast);
        /* int32 number = 6; */
        if (message.number !== 0)
            writer.tag(6, WireType.Varint).int32(message.number);
        /* int32 numberOfElements = 7; */
        if (message.numberOfElements !== 0)
            writer.tag(7, WireType.Varint).int32(message.numberOfElements);
        /* int32 size = 8; */
        if (message.size !== 0)
            writer.tag(8, WireType.Varint).int32(message.size);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.account.GetMobileNumberPageByAppIdResponse
 */
export const GetMobileNumberPageByAppIdResponse = new GetMobileNumberPageByAppIdResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetMobileNumberPageByAccountsRequest$Type extends MessageType<GetMobileNumberPageByAccountsRequest> {
    constructor() {
        super("base.account.GetMobileNumberPageByAccountsRequest", [
            { no: 1, name: "accountIds", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 3 /*ScalarType.INT64*/ },
            { no: 2, name: "pageNum", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "pageSize", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<GetMobileNumberPageByAccountsRequest>): GetMobileNumberPageByAccountsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accountIds = [];
        message.pageNum = 0;
        message.pageSize = 0;
        if (value !== undefined)
            reflectionMergePartial<GetMobileNumberPageByAccountsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetMobileNumberPageByAccountsRequest): GetMobileNumberPageByAccountsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated int64 accountIds */ 1:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.accountIds.push(reader.int64().toString());
                    else
                        message.accountIds.push(reader.int64().toString());
                    break;
                case /* int32 pageNum */ 2:
                    message.pageNum = reader.int32();
                    break;
                case /* int32 pageSize */ 3:
                    message.pageSize = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetMobileNumberPageByAccountsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated int64 accountIds = 1; */
        if (message.accountIds.length) {
            writer.tag(1, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.accountIds.length; i++)
                writer.int64(message.accountIds[i]);
            writer.join();
        }
        /* int32 pageNum = 2; */
        if (message.pageNum !== 0)
            writer.tag(2, WireType.Varint).int32(message.pageNum);
        /* int32 pageSize = 3; */
        if (message.pageSize !== 0)
            writer.tag(3, WireType.Varint).int32(message.pageSize);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.account.GetMobileNumberPageByAccountsRequest
 */
export const GetMobileNumberPageByAccountsRequest = new GetMobileNumberPageByAccountsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetMobileNumberPageByAccountsResponse$Type extends MessageType<GetMobileNumberPageByAccountsResponse> {
    constructor() {
        super("base.account.GetMobileNumberPageByAccountsResponse", [
            { no: 1, name: "result", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => GetMobileNumberByAccountsResponse_MobileNumberByAccountResult },
            { no: 2, name: "totalElements", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 3, name: "totalPages", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "isFirst", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "isLast", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "numberOfElements", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 8, name: "size", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<GetMobileNumberPageByAccountsResponse>): GetMobileNumberPageByAccountsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.result = [];
        message.totalElements = "0";
        message.totalPages = 0;
        message.isFirst = false;
        message.isLast = false;
        message.number = 0;
        message.numberOfElements = 0;
        message.size = 0;
        if (value !== undefined)
            reflectionMergePartial<GetMobileNumberPageByAccountsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetMobileNumberPageByAccountsResponse): GetMobileNumberPageByAccountsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated base.account.GetMobileNumberByAccountsResponse.MobileNumberByAccountResult result */ 1:
                    message.result.push(GetMobileNumberByAccountsResponse_MobileNumberByAccountResult.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int64 totalElements */ 2:
                    message.totalElements = reader.int64().toString();
                    break;
                case /* int32 totalPages */ 3:
                    message.totalPages = reader.int32();
                    break;
                case /* bool isFirst */ 4:
                    message.isFirst = reader.bool();
                    break;
                case /* bool isLast */ 5:
                    message.isLast = reader.bool();
                    break;
                case /* int32 number */ 6:
                    message.number = reader.int32();
                    break;
                case /* int32 numberOfElements */ 7:
                    message.numberOfElements = reader.int32();
                    break;
                case /* int32 size */ 8:
                    message.size = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetMobileNumberPageByAccountsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated base.account.GetMobileNumberByAccountsResponse.MobileNumberByAccountResult result = 1; */
        for (let i = 0; i < message.result.length; i++)
            GetMobileNumberByAccountsResponse_MobileNumberByAccountResult.internalBinaryWrite(message.result[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int64 totalElements = 2; */
        if (message.totalElements !== "0")
            writer.tag(2, WireType.Varint).int64(message.totalElements);
        /* int32 totalPages = 3; */
        if (message.totalPages !== 0)
            writer.tag(3, WireType.Varint).int32(message.totalPages);
        /* bool isFirst = 4; */
        if (message.isFirst !== false)
            writer.tag(4, WireType.Varint).bool(message.isFirst);
        /* bool isLast = 5; */
        if (message.isLast !== false)
            writer.tag(5, WireType.Varint).bool(message.isLast);
        /* int32 number = 6; */
        if (message.number !== 0)
            writer.tag(6, WireType.Varint).int32(message.number);
        /* int32 numberOfElements = 7; */
        if (message.numberOfElements !== 0)
            writer.tag(7, WireType.Varint).int32(message.numberOfElements);
        /* int32 size = 8; */
        if (message.size !== 0)
            writer.tag(8, WireType.Varint).int32(message.size);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.account.GetMobileNumberPageByAccountsResponse
 */
export const GetMobileNumberPageByAccountsResponse = new GetMobileNumberPageByAccountsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetByCreateTimestampBetweenRequest$Type extends MessageType<GetByCreateTimestampBetweenRequest> {
    constructor() {
        super("base.account.GetByCreateTimestampBetweenRequest", [
            { no: 1, name: "startTimestamp", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 2, name: "endTimestamp", kind: "scalar", T: 3 /*ScalarType.INT64*/ }
        ]);
    }
    create(value?: PartialMessage<GetByCreateTimestampBetweenRequest>): GetByCreateTimestampBetweenRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.startTimestamp = "0";
        message.endTimestamp = "0";
        if (value !== undefined)
            reflectionMergePartial<GetByCreateTimestampBetweenRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetByCreateTimestampBetweenRequest): GetByCreateTimestampBetweenRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 startTimestamp */ 1:
                    message.startTimestamp = reader.int64().toString();
                    break;
                case /* int64 endTimestamp */ 2:
                    message.endTimestamp = reader.int64().toString();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetByCreateTimestampBetweenRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 startTimestamp = 1; */
        if (message.startTimestamp !== "0")
            writer.tag(1, WireType.Varint).int64(message.startTimestamp);
        /* int64 endTimestamp = 2; */
        if (message.endTimestamp !== "0")
            writer.tag(2, WireType.Varint).int64(message.endTimestamp);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.account.GetByCreateTimestampBetweenRequest
 */
export const GetByCreateTimestampBetweenRequest = new GetByCreateTimestampBetweenRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetByCreateTimestampBetweenResponse$Type extends MessageType<GetByCreateTimestampBetweenResponse> {
    constructor() {
        super("base.account.GetByCreateTimestampBetweenResponse", [
            { no: 1, name: "accountIds", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 3 /*ScalarType.INT64*/ }
        ]);
    }
    create(value?: PartialMessage<GetByCreateTimestampBetweenResponse>): GetByCreateTimestampBetweenResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accountIds = [];
        if (value !== undefined)
            reflectionMergePartial<GetByCreateTimestampBetweenResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetByCreateTimestampBetweenResponse): GetByCreateTimestampBetweenResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated int64 accountIds */ 1:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.accountIds.push(reader.int64().toString());
                    else
                        message.accountIds.push(reader.int64().toString());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetByCreateTimestampBetweenResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated int64 accountIds = 1; */
        if (message.accountIds.length) {
            writer.tag(1, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.accountIds.length; i++)
                writer.int64(message.accountIds[i]);
            writer.join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.account.GetByCreateTimestampBetweenResponse
 */
export const GetByCreateTimestampBetweenResponse = new GetByCreateTimestampBetweenResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetByMobileNumberContainsRequest$Type extends MessageType<GetByMobileNumberContainsRequest> {
    constructor() {
        super("base.account.GetByMobileNumberContainsRequest", [
            { no: 1, name: "mobileNumber", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<GetByMobileNumberContainsRequest>): GetByMobileNumberContainsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.mobileNumber = "";
        if (value !== undefined)
            reflectionMergePartial<GetByMobileNumberContainsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetByMobileNumberContainsRequest): GetByMobileNumberContainsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string mobileNumber */ 1:
                    message.mobileNumber = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetByMobileNumberContainsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string mobileNumber = 1; */
        if (message.mobileNumber !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.mobileNumber);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.account.GetByMobileNumberContainsRequest
 */
export const GetByMobileNumberContainsRequest = new GetByMobileNumberContainsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetByMobileNumberContainsResponse$Type extends MessageType<GetByMobileNumberContainsResponse> {
    constructor() {
        super("base.account.GetByMobileNumberContainsResponse", [
            { no: 1, name: "accountIds", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 3 /*ScalarType.INT64*/ }
        ]);
    }
    create(value?: PartialMessage<GetByMobileNumberContainsResponse>): GetByMobileNumberContainsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accountIds = [];
        if (value !== undefined)
            reflectionMergePartial<GetByMobileNumberContainsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetByMobileNumberContainsResponse): GetByMobileNumberContainsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated int64 accountIds */ 1:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.accountIds.push(reader.int64().toString());
                    else
                        message.accountIds.push(reader.int64().toString());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetByMobileNumberContainsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated int64 accountIds = 1; */
        if (message.accountIds.length) {
            writer.tag(1, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.accountIds.length; i++)
                writer.int64(message.accountIds[i]);
            writer.join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.account.GetByMobileNumberContainsResponse
 */
export const GetByMobileNumberContainsResponse = new GetByMobileNumberContainsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetCreationTimestampByAccountIdsRequest$Type extends MessageType<GetCreationTimestampByAccountIdsRequest> {
    constructor() {
        super("base.account.GetCreationTimestampByAccountIdsRequest", [
            { no: 1, name: "accountIds", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 3 /*ScalarType.INT64*/ }
        ]);
    }
    create(value?: PartialMessage<GetCreationTimestampByAccountIdsRequest>): GetCreationTimestampByAccountIdsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accountIds = [];
        if (value !== undefined)
            reflectionMergePartial<GetCreationTimestampByAccountIdsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetCreationTimestampByAccountIdsRequest): GetCreationTimestampByAccountIdsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated int64 accountIds */ 1:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.accountIds.push(reader.int64().toString());
                    else
                        message.accountIds.push(reader.int64().toString());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetCreationTimestampByAccountIdsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated int64 accountIds = 1; */
        if (message.accountIds.length) {
            writer.tag(1, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.accountIds.length; i++)
                writer.int64(message.accountIds[i]);
            writer.join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.account.GetCreationTimestampByAccountIdsRequest
 */
export const GetCreationTimestampByAccountIdsRequest = new GetCreationTimestampByAccountIdsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetCreationTimestampByAccountIdsResponse$Type extends MessageType<GetCreationTimestampByAccountIdsResponse> {
    constructor() {
        super("base.account.GetCreationTimestampByAccountIdsResponse", [
            { no: 1, name: "account", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => CreationTimestampByAccountIds }
        ]);
    }
    create(value?: PartialMessage<GetCreationTimestampByAccountIdsResponse>): GetCreationTimestampByAccountIdsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.account = [];
        if (value !== undefined)
            reflectionMergePartial<GetCreationTimestampByAccountIdsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetCreationTimestampByAccountIdsResponse): GetCreationTimestampByAccountIdsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated base.account.CreationTimestampByAccountIds account */ 1:
                    message.account.push(CreationTimestampByAccountIds.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetCreationTimestampByAccountIdsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated base.account.CreationTimestampByAccountIds account = 1; */
        for (let i = 0; i < message.account.length; i++)
            CreationTimestampByAccountIds.internalBinaryWrite(message.account[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.account.GetCreationTimestampByAccountIdsResponse
 */
export const GetCreationTimestampByAccountIdsResponse = new GetCreationTimestampByAccountIdsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreationTimestampByAccountIds$Type extends MessageType<CreationTimestampByAccountIds> {
    constructor() {
        super("base.account.CreationTimestampByAccountIds", [
            { no: 1, name: "accountId", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 2, name: "creationTimestamp", kind: "scalar", T: 3 /*ScalarType.INT64*/ }
        ]);
    }
    create(value?: PartialMessage<CreationTimestampByAccountIds>): CreationTimestampByAccountIds {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accountId = "0";
        message.creationTimestamp = "0";
        if (value !== undefined)
            reflectionMergePartial<CreationTimestampByAccountIds>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreationTimestampByAccountIds): CreationTimestampByAccountIds {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 accountId */ 1:
                    message.accountId = reader.int64().toString();
                    break;
                case /* int64 creationTimestamp */ 2:
                    message.creationTimestamp = reader.int64().toString();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreationTimestampByAccountIds, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 accountId = 1; */
        if (message.accountId !== "0")
            writer.tag(1, WireType.Varint).int64(message.accountId);
        /* int64 creationTimestamp = 2; */
        if (message.creationTimestamp !== "0")
            writer.tag(2, WireType.Varint).int64(message.creationTimestamp);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.account.CreationTimestampByAccountIds
 */
export const CreationTimestampByAccountIds = new CreationTimestampByAccountIds$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BindingAccountIdForMobileNumberRequest$Type extends MessageType<BindingAccountIdForMobileNumberRequest> {
    constructor() {
        super("base.account.BindingAccountIdForMobileNumberRequest", [
            { no: 1, name: "mobileNumber", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "countryCode", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<BindingAccountIdForMobileNumberRequest>): BindingAccountIdForMobileNumberRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.mobileNumber = "";
        message.countryCode = "";
        if (value !== undefined)
            reflectionMergePartial<BindingAccountIdForMobileNumberRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BindingAccountIdForMobileNumberRequest): BindingAccountIdForMobileNumberRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string mobileNumber */ 1:
                    message.mobileNumber = reader.string();
                    break;
                case /* string countryCode */ 2:
                    message.countryCode = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BindingAccountIdForMobileNumberRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string mobileNumber = 1; */
        if (message.mobileNumber !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.mobileNumber);
        /* string countryCode = 2; */
        if (message.countryCode !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.countryCode);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.account.BindingAccountIdForMobileNumberRequest
 */
export const BindingAccountIdForMobileNumberRequest = new BindingAccountIdForMobileNumberRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BindingAccountIdForMobileNumberResponse$Type extends MessageType<BindingAccountIdForMobileNumberResponse> {
    constructor() {
        super("base.account.BindingAccountIdForMobileNumberResponse", [
            { no: 1, name: "mobileAccountId", kind: "scalar", T: 3 /*ScalarType.INT64*/ }
        ]);
    }
    create(value?: PartialMessage<BindingAccountIdForMobileNumberResponse>): BindingAccountIdForMobileNumberResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.mobileAccountId = "0";
        if (value !== undefined)
            reflectionMergePartial<BindingAccountIdForMobileNumberResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BindingAccountIdForMobileNumberResponse): BindingAccountIdForMobileNumberResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 mobileAccountId */ 1:
                    message.mobileAccountId = reader.int64().toString();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BindingAccountIdForMobileNumberResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 mobileAccountId = 1; */
        if (message.mobileAccountId !== "0")
            writer.tag(1, WireType.Varint).int64(message.mobileAccountId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.account.BindingAccountIdForMobileNumberResponse
 */
export const BindingAccountIdForMobileNumberResponse = new BindingAccountIdForMobileNumberResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CheckMobileNumberExistenceRequest$Type extends MessageType<CheckMobileNumberExistenceRequest> {
    constructor() {
        super("base.account.CheckMobileNumberExistenceRequest", []);
    }
    create(value?: PartialMessage<CheckMobileNumberExistenceRequest>): CheckMobileNumberExistenceRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<CheckMobileNumberExistenceRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CheckMobileNumberExistenceRequest): CheckMobileNumberExistenceRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CheckMobileNumberExistenceRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.account.CheckMobileNumberExistenceRequest
 */
export const CheckMobileNumberExistenceRequest = new CheckMobileNumberExistenceRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CheckMobileNumberExistenceResponse$Type extends MessageType<CheckMobileNumberExistenceResponse> {
    constructor() {
        super("base.account.CheckMobileNumberExistenceResponse", [
            { no: 1, name: "isExisted", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<CheckMobileNumberExistenceResponse>): CheckMobileNumberExistenceResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.isExisted = false;
        if (value !== undefined)
            reflectionMergePartial<CheckMobileNumberExistenceResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CheckMobileNumberExistenceResponse): CheckMobileNumberExistenceResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool isExisted */ 1:
                    message.isExisted = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CheckMobileNumberExistenceResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool isExisted = 1; */
        if (message.isExisted !== false)
            writer.tag(1, WireType.Varint).bool(message.isExisted);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.account.CheckMobileNumberExistenceResponse
 */
export const CheckMobileNumberExistenceResponse = new CheckMobileNumberExistenceResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetMobileNumberByAccountsRequest$Type extends MessageType<GetMobileNumberByAccountsRequest> {
    constructor() {
        super("base.account.GetMobileNumberByAccountsRequest", [
            { no: 1, name: "accountIds", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 3 /*ScalarType.INT64*/ }
        ]);
    }
    create(value?: PartialMessage<GetMobileNumberByAccountsRequest>): GetMobileNumberByAccountsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accountIds = [];
        if (value !== undefined)
            reflectionMergePartial<GetMobileNumberByAccountsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetMobileNumberByAccountsRequest): GetMobileNumberByAccountsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated int64 accountIds */ 1:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.accountIds.push(reader.int64().toString());
                    else
                        message.accountIds.push(reader.int64().toString());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetMobileNumberByAccountsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated int64 accountIds = 1; */
        if (message.accountIds.length) {
            writer.tag(1, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.accountIds.length; i++)
                writer.int64(message.accountIds[i]);
            writer.join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.account.GetMobileNumberByAccountsRequest
 */
export const GetMobileNumberByAccountsRequest = new GetMobileNumberByAccountsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetMobileNumberByAccountsResponse$Type extends MessageType<GetMobileNumberByAccountsResponse> {
    constructor() {
        super("base.account.GetMobileNumberByAccountsResponse", [
            { no: 1, name: "result", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => GetMobileNumberByAccountsResponse_MobileNumberByAccountResult }
        ]);
    }
    create(value?: PartialMessage<GetMobileNumberByAccountsResponse>): GetMobileNumberByAccountsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.result = [];
        if (value !== undefined)
            reflectionMergePartial<GetMobileNumberByAccountsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetMobileNumberByAccountsResponse): GetMobileNumberByAccountsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated base.account.GetMobileNumberByAccountsResponse.MobileNumberByAccountResult result */ 1:
                    message.result.push(GetMobileNumberByAccountsResponse_MobileNumberByAccountResult.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetMobileNumberByAccountsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated base.account.GetMobileNumberByAccountsResponse.MobileNumberByAccountResult result = 1; */
        for (let i = 0; i < message.result.length; i++)
            GetMobileNumberByAccountsResponse_MobileNumberByAccountResult.internalBinaryWrite(message.result[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.account.GetMobileNumberByAccountsResponse
 */
export const GetMobileNumberByAccountsResponse = new GetMobileNumberByAccountsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetMobileNumberByAccountsResponse_MobileNumberByAccountResult$Type extends MessageType<GetMobileNumberByAccountsResponse_MobileNumberByAccountResult> {
    constructor() {
        super("base.account.GetMobileNumberByAccountsResponse.MobileNumberByAccountResult", [
            { no: 1, name: "accountId", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 2, name: "mobileNumber", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "timestamp", kind: "scalar", T: 3 /*ScalarType.INT64*/ }
        ]);
    }
    create(value?: PartialMessage<GetMobileNumberByAccountsResponse_MobileNumberByAccountResult>): GetMobileNumberByAccountsResponse_MobileNumberByAccountResult {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accountId = "0";
        message.mobileNumber = "";
        message.timestamp = "0";
        if (value !== undefined)
            reflectionMergePartial<GetMobileNumberByAccountsResponse_MobileNumberByAccountResult>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetMobileNumberByAccountsResponse_MobileNumberByAccountResult): GetMobileNumberByAccountsResponse_MobileNumberByAccountResult {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 accountId */ 1:
                    message.accountId = reader.int64().toString();
                    break;
                case /* string mobileNumber */ 2:
                    message.mobileNumber = reader.string();
                    break;
                case /* int64 timestamp */ 3:
                    message.timestamp = reader.int64().toString();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetMobileNumberByAccountsResponse_MobileNumberByAccountResult, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 accountId = 1; */
        if (message.accountId !== "0")
            writer.tag(1, WireType.Varint).int64(message.accountId);
        /* string mobileNumber = 2; */
        if (message.mobileNumber !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.mobileNumber);
        /* int64 timestamp = 3; */
        if (message.timestamp !== "0")
            writer.tag(3, WireType.Varint).int64(message.timestamp);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.account.GetMobileNumberByAccountsResponse.MobileNumberByAccountResult
 */
export const GetMobileNumberByAccountsResponse_MobileNumberByAccountResult = new GetMobileNumberByAccountsResponse_MobileNumberByAccountResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RegisterByPasswordRequest$Type extends MessageType<RegisterByPasswordRequest> {
    constructor() {
        super("base.account.RegisterByPasswordRequest", [
            { no: 1, name: "countryCode", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "mobileNumber", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "captcha", kind: "message", T: () => StringValue },
            { no: 4, name: "password", kind: "message", T: () => StringValue },
            { no: 5, name: "client", kind: "message", T: () => StringValue },
            { no: 6, name: "activated", kind: "message", T: () => BoolValue }
        ]);
    }
    create(value?: PartialMessage<RegisterByPasswordRequest>): RegisterByPasswordRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.countryCode = "";
        message.mobileNumber = "";
        if (value !== undefined)
            reflectionMergePartial<RegisterByPasswordRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RegisterByPasswordRequest): RegisterByPasswordRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string countryCode */ 1:
                    message.countryCode = reader.string();
                    break;
                case /* string mobileNumber */ 2:
                    message.mobileNumber = reader.string();
                    break;
                case /* google.protobuf.StringValue captcha */ 3:
                    message.captcha = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.captcha);
                    break;
                case /* google.protobuf.StringValue password */ 4:
                    message.password = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.password);
                    break;
                case /* google.protobuf.StringValue client */ 5:
                    message.client = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.client);
                    break;
                case /* google.protobuf.BoolValue activated */ 6:
                    message.activated = BoolValue.internalBinaryRead(reader, reader.uint32(), options, message.activated);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RegisterByPasswordRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string countryCode = 1; */
        if (message.countryCode !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.countryCode);
        /* string mobileNumber = 2; */
        if (message.mobileNumber !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.mobileNumber);
        /* google.protobuf.StringValue captcha = 3; */
        if (message.captcha)
            StringValue.internalBinaryWrite(message.captcha, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue password = 4; */
        if (message.password)
            StringValue.internalBinaryWrite(message.password, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue client = 5; */
        if (message.client)
            StringValue.internalBinaryWrite(message.client, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.BoolValue activated = 6; */
        if (message.activated)
            BoolValue.internalBinaryWrite(message.activated, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.account.RegisterByPasswordRequest
 */
export const RegisterByPasswordRequest = new RegisterByPasswordRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetPasswordForMobileRequest$Type extends MessageType<SetPasswordForMobileRequest> {
    constructor() {
        super("base.account.SetPasswordForMobileRequest", [
            { no: 1, name: "countryCode", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "mobileNumber", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "captcha", kind: "message", T: () => StringValue },
            { no: 4, name: "password", kind: "message", T: () => StringValue }
        ]);
    }
    create(value?: PartialMessage<SetPasswordForMobileRequest>): SetPasswordForMobileRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.countryCode = "";
        message.mobileNumber = "";
        if (value !== undefined)
            reflectionMergePartial<SetPasswordForMobileRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SetPasswordForMobileRequest): SetPasswordForMobileRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string countryCode */ 1:
                    message.countryCode = reader.string();
                    break;
                case /* string mobileNumber */ 2:
                    message.mobileNumber = reader.string();
                    break;
                case /* google.protobuf.StringValue captcha */ 3:
                    message.captcha = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.captcha);
                    break;
                case /* google.protobuf.StringValue password */ 4:
                    message.password = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.password);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SetPasswordForMobileRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string countryCode = 1; */
        if (message.countryCode !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.countryCode);
        /* string mobileNumber = 2; */
        if (message.mobileNumber !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.mobileNumber);
        /* google.protobuf.StringValue captcha = 3; */
        if (message.captcha)
            StringValue.internalBinaryWrite(message.captcha, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue password = 4; */
        if (message.password)
            StringValue.internalBinaryWrite(message.password, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.account.SetPasswordForMobileRequest
 */
export const SetPasswordForMobileRequest = new SetPasswordForMobileRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetPasswordForMobileResponse$Type extends MessageType<SetPasswordForMobileResponse> {
    constructor() {
        super("base.account.SetPasswordForMobileResponse", [
            { no: 1, name: "isSuccess", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<SetPasswordForMobileResponse>): SetPasswordForMobileResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.isSuccess = false;
        if (value !== undefined)
            reflectionMergePartial<SetPasswordForMobileResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SetPasswordForMobileResponse): SetPasswordForMobileResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool isSuccess */ 1:
                    message.isSuccess = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SetPasswordForMobileResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool isSuccess = 1; */
        if (message.isSuccess !== false)
            writer.tag(1, WireType.Varint).bool(message.isSuccess);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.account.SetPasswordForMobileResponse
 */
export const SetPasswordForMobileResponse = new SetPasswordForMobileResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RegisterByPasswordResponse$Type extends MessageType<RegisterByPasswordResponse> {
    constructor() {
        super("base.account.RegisterByPasswordResponse", [
            { no: 1, name: "accessToken", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "accountId", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 3, name: "expiresTimestamp", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 4, name: "activated", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "refreshToken", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "expiresIn", kind: "scalar", T: 3 /*ScalarType.INT64*/ }
        ]);
    }
    create(value?: PartialMessage<RegisterByPasswordResponse>): RegisterByPasswordResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accessToken = "";
        message.accountId = "0";
        message.expiresTimestamp = "0";
        message.activated = false;
        message.refreshToken = "";
        message.expiresIn = "0";
        if (value !== undefined)
            reflectionMergePartial<RegisterByPasswordResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RegisterByPasswordResponse): RegisterByPasswordResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string accessToken */ 1:
                    message.accessToken = reader.string();
                    break;
                case /* int64 accountId */ 2:
                    message.accountId = reader.int64().toString();
                    break;
                case /* int64 expiresTimestamp */ 3:
                    message.expiresTimestamp = reader.int64().toString();
                    break;
                case /* bool activated */ 4:
                    message.activated = reader.bool();
                    break;
                case /* string refreshToken */ 5:
                    message.refreshToken = reader.string();
                    break;
                case /* int64 expiresIn */ 6:
                    message.expiresIn = reader.int64().toString();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RegisterByPasswordResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string accessToken = 1; */
        if (message.accessToken !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.accessToken);
        /* int64 accountId = 2; */
        if (message.accountId !== "0")
            writer.tag(2, WireType.Varint).int64(message.accountId);
        /* int64 expiresTimestamp = 3; */
        if (message.expiresTimestamp !== "0")
            writer.tag(3, WireType.Varint).int64(message.expiresTimestamp);
        /* bool activated = 4; */
        if (message.activated !== false)
            writer.tag(4, WireType.Varint).bool(message.activated);
        /* string refreshToken = 5; */
        if (message.refreshToken !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.refreshToken);
        /* int64 expiresIn = 6; */
        if (message.expiresIn !== "0")
            writer.tag(6, WireType.Varint).int64(message.expiresIn);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.account.RegisterByPasswordResponse
 */
export const RegisterByPasswordResponse = new RegisterByPasswordResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RegisterByCaptchaRequest$Type extends MessageType<RegisterByCaptchaRequest> {
    constructor() {
        super("base.account.RegisterByCaptchaRequest", [
            { no: 1, name: "countryCode", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "mobileNumber", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "captcha", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "client", kind: "message", T: () => StringValue }
        ]);
    }
    create(value?: PartialMessage<RegisterByCaptchaRequest>): RegisterByCaptchaRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.countryCode = "";
        message.mobileNumber = "";
        message.captcha = "";
        if (value !== undefined)
            reflectionMergePartial<RegisterByCaptchaRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RegisterByCaptchaRequest): RegisterByCaptchaRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string countryCode */ 1:
                    message.countryCode = reader.string();
                    break;
                case /* string mobileNumber */ 2:
                    message.mobileNumber = reader.string();
                    break;
                case /* string captcha */ 3:
                    message.captcha = reader.string();
                    break;
                case /* google.protobuf.StringValue client */ 4:
                    message.client = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.client);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RegisterByCaptchaRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string countryCode = 1; */
        if (message.countryCode !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.countryCode);
        /* string mobileNumber = 2; */
        if (message.mobileNumber !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.mobileNumber);
        /* string captcha = 3; */
        if (message.captcha !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.captcha);
        /* google.protobuf.StringValue client = 4; */
        if (message.client)
            StringValue.internalBinaryWrite(message.client, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.account.RegisterByCaptchaRequest
 */
export const RegisterByCaptchaRequest = new RegisterByCaptchaRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RegisterByCaptchaResponse$Type extends MessageType<RegisterByCaptchaResponse> {
    constructor() {
        super("base.account.RegisterByCaptchaResponse", [
            { no: 1, name: "accessToken", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "accountId", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 3, name: "expiresTimestamp", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 4, name: "activated", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "refreshToken", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "expiresIn", kind: "scalar", T: 3 /*ScalarType.INT64*/ }
        ]);
    }
    create(value?: PartialMessage<RegisterByCaptchaResponse>): RegisterByCaptchaResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accessToken = "";
        message.accountId = "0";
        message.expiresTimestamp = "0";
        message.activated = false;
        message.refreshToken = "";
        message.expiresIn = "0";
        if (value !== undefined)
            reflectionMergePartial<RegisterByCaptchaResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RegisterByCaptchaResponse): RegisterByCaptchaResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string accessToken */ 1:
                    message.accessToken = reader.string();
                    break;
                case /* int64 accountId */ 2:
                    message.accountId = reader.int64().toString();
                    break;
                case /* int64 expiresTimestamp */ 3:
                    message.expiresTimestamp = reader.int64().toString();
                    break;
                case /* bool activated */ 4:
                    message.activated = reader.bool();
                    break;
                case /* string refreshToken */ 5:
                    message.refreshToken = reader.string();
                    break;
                case /* int64 expiresIn */ 6:
                    message.expiresIn = reader.int64().toString();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RegisterByCaptchaResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string accessToken = 1; */
        if (message.accessToken !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.accessToken);
        /* int64 accountId = 2; */
        if (message.accountId !== "0")
            writer.tag(2, WireType.Varint).int64(message.accountId);
        /* int64 expiresTimestamp = 3; */
        if (message.expiresTimestamp !== "0")
            writer.tag(3, WireType.Varint).int64(message.expiresTimestamp);
        /* bool activated = 4; */
        if (message.activated !== false)
            writer.tag(4, WireType.Varint).bool(message.activated);
        /* string refreshToken = 5; */
        if (message.refreshToken !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.refreshToken);
        /* int64 expiresIn = 6; */
        if (message.expiresIn !== "0")
            writer.tag(6, WireType.Varint).int64(message.expiresIn);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.account.RegisterByCaptchaResponse
 */
export const RegisterByCaptchaResponse = new RegisterByCaptchaResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RegisterRequest$Type extends MessageType<RegisterRequest> {
    constructor() {
        super("base.account.RegisterRequest", [
            { no: 1, name: "countryCode", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "mobileNumber", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "client", kind: "message", T: () => StringValue },
            { no: 5, name: "activated", kind: "message", T: () => BoolValue }
        ]);
    }
    create(value?: PartialMessage<RegisterRequest>): RegisterRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.countryCode = "";
        message.mobileNumber = "";
        if (value !== undefined)
            reflectionMergePartial<RegisterRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RegisterRequest): RegisterRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string countryCode */ 1:
                    message.countryCode = reader.string();
                    break;
                case /* string mobileNumber */ 2:
                    message.mobileNumber = reader.string();
                    break;
                case /* google.protobuf.StringValue client */ 4:
                    message.client = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.client);
                    break;
                case /* google.protobuf.BoolValue activated */ 5:
                    message.activated = BoolValue.internalBinaryRead(reader, reader.uint32(), options, message.activated);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RegisterRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string countryCode = 1; */
        if (message.countryCode !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.countryCode);
        /* string mobileNumber = 2; */
        if (message.mobileNumber !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.mobileNumber);
        /* google.protobuf.StringValue client = 4; */
        if (message.client)
            StringValue.internalBinaryWrite(message.client, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.BoolValue activated = 5; */
        if (message.activated)
            BoolValue.internalBinaryWrite(message.activated, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.account.RegisterRequest
 */
export const RegisterRequest = new RegisterRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RegisterResponse$Type extends MessageType<RegisterResponse> {
    constructor() {
        super("base.account.RegisterResponse", [
            { no: 1, name: "accountId", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 2, name: "accessToken", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "expiresTimestamp", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 4, name: "activated", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "refreshToken", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "expiresIn", kind: "scalar", T: 3 /*ScalarType.INT64*/ }
        ]);
    }
    create(value?: PartialMessage<RegisterResponse>): RegisterResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accountId = "0";
        message.accessToken = "";
        message.expiresTimestamp = "0";
        message.activated = false;
        message.refreshToken = "";
        message.expiresIn = "0";
        if (value !== undefined)
            reflectionMergePartial<RegisterResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RegisterResponse): RegisterResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 accountId */ 1:
                    message.accountId = reader.int64().toString();
                    break;
                case /* string accessToken */ 2:
                    message.accessToken = reader.string();
                    break;
                case /* int64 expiresTimestamp */ 3:
                    message.expiresTimestamp = reader.int64().toString();
                    break;
                case /* bool activated */ 4:
                    message.activated = reader.bool();
                    break;
                case /* string refreshToken */ 5:
                    message.refreshToken = reader.string();
                    break;
                case /* int64 expiresIn */ 6:
                    message.expiresIn = reader.int64().toString();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RegisterResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 accountId = 1; */
        if (message.accountId !== "0")
            writer.tag(1, WireType.Varint).int64(message.accountId);
        /* string accessToken = 2; */
        if (message.accessToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.accessToken);
        /* int64 expiresTimestamp = 3; */
        if (message.expiresTimestamp !== "0")
            writer.tag(3, WireType.Varint).int64(message.expiresTimestamp);
        /* bool activated = 4; */
        if (message.activated !== false)
            writer.tag(4, WireType.Varint).bool(message.activated);
        /* string refreshToken = 5; */
        if (message.refreshToken !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.refreshToken);
        /* int64 expiresIn = 6; */
        if (message.expiresIn !== "0")
            writer.tag(6, WireType.Varint).int64(message.expiresIn);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.account.RegisterResponse
 */
export const RegisterResponse = new RegisterResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAccountIdRequest$Type extends MessageType<GetAccountIdRequest> {
    constructor() {
        super("base.account.GetAccountIdRequest", [
            { no: 1, name: "countryCode", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "mobileNumber", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<GetAccountIdRequest>): GetAccountIdRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.countryCode = "";
        message.mobileNumber = "";
        if (value !== undefined)
            reflectionMergePartial<GetAccountIdRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetAccountIdRequest): GetAccountIdRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string countryCode */ 1:
                    message.countryCode = reader.string();
                    break;
                case /* string mobileNumber */ 2:
                    message.mobileNumber = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetAccountIdRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string countryCode = 1; */
        if (message.countryCode !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.countryCode);
        /* string mobileNumber = 2; */
        if (message.mobileNumber !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.mobileNumber);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.account.GetAccountIdRequest
 */
export const GetAccountIdRequest = new GetAccountIdRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAccountIdResponse$Type extends MessageType<GetAccountIdResponse> {
    constructor() {
        super("base.account.GetAccountIdResponse", [
            { no: 1, name: "accountId", kind: "scalar", T: 3 /*ScalarType.INT64*/ }
        ]);
    }
    create(value?: PartialMessage<GetAccountIdResponse>): GetAccountIdResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accountId = "0";
        if (value !== undefined)
            reflectionMergePartial<GetAccountIdResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetAccountIdResponse): GetAccountIdResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 accountId */ 1:
                    message.accountId = reader.int64().toString();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetAccountIdResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 accountId = 1; */
        if (message.accountId !== "0")
            writer.tag(1, WireType.Varint).int64(message.accountId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.account.GetAccountIdResponse
 */
export const GetAccountIdResponse = new GetAccountIdResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class IsRegisteredRequest$Type extends MessageType<IsRegisteredRequest> {
    constructor() {
        super("base.account.IsRegisteredRequest", [
            { no: 1, name: "countryCode", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "mobileNumber", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<IsRegisteredRequest>): IsRegisteredRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.countryCode = "";
        message.mobileNumber = "";
        if (value !== undefined)
            reflectionMergePartial<IsRegisteredRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: IsRegisteredRequest): IsRegisteredRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string countryCode */ 1:
                    message.countryCode = reader.string();
                    break;
                case /* string mobileNumber */ 2:
                    message.mobileNumber = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: IsRegisteredRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string countryCode = 1; */
        if (message.countryCode !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.countryCode);
        /* string mobileNumber = 2; */
        if (message.mobileNumber !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.mobileNumber);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.account.IsRegisteredRequest
 */
export const IsRegisteredRequest = new IsRegisteredRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class IsRegisteredResponse$Type extends MessageType<IsRegisteredResponse> {
    constructor() {
        super("base.account.IsRegisteredResponse", [
            { no: 1, name: "isRegistered", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "activated", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<IsRegisteredResponse>): IsRegisteredResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.isRegistered = false;
        message.activated = false;
        if (value !== undefined)
            reflectionMergePartial<IsRegisteredResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: IsRegisteredResponse): IsRegisteredResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool isRegistered */ 1:
                    message.isRegistered = reader.bool();
                    break;
                case /* bool activated */ 2:
                    message.activated = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: IsRegisteredResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool isRegistered = 1; */
        if (message.isRegistered !== false)
            writer.tag(1, WireType.Varint).bool(message.isRegistered);
        /* bool activated = 2; */
        if (message.activated !== false)
            writer.tag(2, WireType.Varint).bool(message.activated);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.account.IsRegisteredResponse
 */
export const IsRegisteredResponse = new IsRegisteredResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class LoginByPasswordRequest$Type extends MessageType<LoginByPasswordRequest> {
    constructor() {
        super("base.account.LoginByPasswordRequest", [
            { no: 1, name: "countryCode", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "mobileNumber", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "password", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "client", kind: "message", T: () => StringValue }
        ]);
    }
    create(value?: PartialMessage<LoginByPasswordRequest>): LoginByPasswordRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.countryCode = "";
        message.mobileNumber = "";
        message.password = "";
        if (value !== undefined)
            reflectionMergePartial<LoginByPasswordRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: LoginByPasswordRequest): LoginByPasswordRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string countryCode */ 1:
                    message.countryCode = reader.string();
                    break;
                case /* string mobileNumber */ 2:
                    message.mobileNumber = reader.string();
                    break;
                case /* string password */ 3:
                    message.password = reader.string();
                    break;
                case /* google.protobuf.StringValue client */ 4:
                    message.client = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.client);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: LoginByPasswordRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string countryCode = 1; */
        if (message.countryCode !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.countryCode);
        /* string mobileNumber = 2; */
        if (message.mobileNumber !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.mobileNumber);
        /* string password = 3; */
        if (message.password !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.password);
        /* google.protobuf.StringValue client = 4; */
        if (message.client)
            StringValue.internalBinaryWrite(message.client, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.account.LoginByPasswordRequest
 */
export const LoginByPasswordRequest = new LoginByPasswordRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class LoginByPasswordResponse$Type extends MessageType<LoginByPasswordResponse> {
    constructor() {
        super("base.account.LoginByPasswordResponse", [
            { no: 1, name: "accessToken", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "activated", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "accountId", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 4, name: "expiresTimestamp", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 5, name: "refreshToken", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "expiresIn", kind: "scalar", T: 3 /*ScalarType.INT64*/ }
        ]);
    }
    create(value?: PartialMessage<LoginByPasswordResponse>): LoginByPasswordResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accessToken = "";
        message.activated = false;
        message.accountId = "0";
        message.expiresTimestamp = "0";
        message.refreshToken = "";
        message.expiresIn = "0";
        if (value !== undefined)
            reflectionMergePartial<LoginByPasswordResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: LoginByPasswordResponse): LoginByPasswordResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string accessToken */ 1:
                    message.accessToken = reader.string();
                    break;
                case /* bool activated */ 2:
                    message.activated = reader.bool();
                    break;
                case /* int64 accountId */ 3:
                    message.accountId = reader.int64().toString();
                    break;
                case /* int64 expiresTimestamp */ 4:
                    message.expiresTimestamp = reader.int64().toString();
                    break;
                case /* string refreshToken */ 5:
                    message.refreshToken = reader.string();
                    break;
                case /* int64 expiresIn */ 6:
                    message.expiresIn = reader.int64().toString();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: LoginByPasswordResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string accessToken = 1; */
        if (message.accessToken !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.accessToken);
        /* bool activated = 2; */
        if (message.activated !== false)
            writer.tag(2, WireType.Varint).bool(message.activated);
        /* int64 accountId = 3; */
        if (message.accountId !== "0")
            writer.tag(3, WireType.Varint).int64(message.accountId);
        /* int64 expiresTimestamp = 4; */
        if (message.expiresTimestamp !== "0")
            writer.tag(4, WireType.Varint).int64(message.expiresTimestamp);
        /* string refreshToken = 5; */
        if (message.refreshToken !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.refreshToken);
        /* int64 expiresIn = 6; */
        if (message.expiresIn !== "0")
            writer.tag(6, WireType.Varint).int64(message.expiresIn);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.account.LoginByPasswordResponse
 */
export const LoginByPasswordResponse = new LoginByPasswordResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class LoginByCaptchaRequest$Type extends MessageType<LoginByCaptchaRequest> {
    constructor() {
        super("base.account.LoginByCaptchaRequest", [
            { no: 1, name: "countryCode", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "mobileNumber", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "captcha", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "client", kind: "message", T: () => StringValue }
        ]);
    }
    create(value?: PartialMessage<LoginByCaptchaRequest>): LoginByCaptchaRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.countryCode = "";
        message.mobileNumber = "";
        message.captcha = "";
        if (value !== undefined)
            reflectionMergePartial<LoginByCaptchaRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: LoginByCaptchaRequest): LoginByCaptchaRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string countryCode */ 1:
                    message.countryCode = reader.string();
                    break;
                case /* string mobileNumber */ 2:
                    message.mobileNumber = reader.string();
                    break;
                case /* string captcha */ 3:
                    message.captcha = reader.string();
                    break;
                case /* google.protobuf.StringValue client */ 4:
                    message.client = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.client);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: LoginByCaptchaRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string countryCode = 1; */
        if (message.countryCode !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.countryCode);
        /* string mobileNumber = 2; */
        if (message.mobileNumber !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.mobileNumber);
        /* string captcha = 3; */
        if (message.captcha !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.captcha);
        /* google.protobuf.StringValue client = 4; */
        if (message.client)
            StringValue.internalBinaryWrite(message.client, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.account.LoginByCaptchaRequest
 */
export const LoginByCaptchaRequest = new LoginByCaptchaRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class LoginByCaptchaResponse$Type extends MessageType<LoginByCaptchaResponse> {
    constructor() {
        super("base.account.LoginByCaptchaResponse", [
            { no: 1, name: "accessToken", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "accountId", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 4, name: "expiresTimestamp", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 5, name: "refreshToken", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "expiresIn", kind: "scalar", T: 3 /*ScalarType.INT64*/ }
        ]);
    }
    create(value?: PartialMessage<LoginByCaptchaResponse>): LoginByCaptchaResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accessToken = "";
        message.accountId = "0";
        message.expiresTimestamp = "0";
        message.refreshToken = "";
        message.expiresIn = "0";
        if (value !== undefined)
            reflectionMergePartial<LoginByCaptchaResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: LoginByCaptchaResponse): LoginByCaptchaResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string accessToken */ 1:
                    message.accessToken = reader.string();
                    break;
                case /* int64 accountId */ 3:
                    message.accountId = reader.int64().toString();
                    break;
                case /* int64 expiresTimestamp */ 4:
                    message.expiresTimestamp = reader.int64().toString();
                    break;
                case /* string refreshToken */ 5:
                    message.refreshToken = reader.string();
                    break;
                case /* int64 expiresIn */ 6:
                    message.expiresIn = reader.int64().toString();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: LoginByCaptchaResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string accessToken = 1; */
        if (message.accessToken !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.accessToken);
        /* int64 accountId = 3; */
        if (message.accountId !== "0")
            writer.tag(3, WireType.Varint).int64(message.accountId);
        /* int64 expiresTimestamp = 4; */
        if (message.expiresTimestamp !== "0")
            writer.tag(4, WireType.Varint).int64(message.expiresTimestamp);
        /* string refreshToken = 5; */
        if (message.refreshToken !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.refreshToken);
        /* int64 expiresIn = 6; */
        if (message.expiresIn !== "0")
            writer.tag(6, WireType.Varint).int64(message.expiresIn);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.account.LoginByCaptchaResponse
 */
export const LoginByCaptchaResponse = new LoginByCaptchaResponse$Type();
/**
 * @generated ServiceType for protobuf service base.account.MobileAccountService
 */
export const MobileAccountService = new ServiceType("base.account.MobileAccountService", [
    { name: "RegisterByPassword", options: { "google.api.http": { post: "/base.account.MobileAccountService/RegisterByPassword", body: "*" } }, I: RegisterByPasswordRequest, O: RegisterByPasswordResponse },
    { name: "SetPasswordForMobile", options: { "google.api.http": { post: "/base.account.MobileAccountService/SetPasswordForMobile", body: "*" } }, I: SetPasswordForMobileRequest, O: SetPasswordForMobileResponse },
    { name: "RegisterByCaptcha", options: { "google.api.http": { post: "/base.account.MobileAccountService/RegisterByCaptcha", body: "*" } }, I: RegisterByCaptchaRequest, O: RegisterByCaptchaResponse },
    { name: "Register", options: { "google.api.http": { post: "/base.account.MobileAccountService/Register", body: "*" } }, I: RegisterRequest, O: RegisterResponse },
    { name: "GetAccountId", options: { "google.api.http": { post: "/base.account.MobileAccountService/GetAccountId", body: "*" } }, I: GetAccountIdRequest, O: GetAccountIdResponse },
    { name: "IsRegistered", options: { "google.api.http": { post: "/base.account.MobileAccountService/IsRegistered", body: "*" } }, I: IsRegisteredRequest, O: IsRegisteredResponse },
    { name: "LoginByPassword", options: { "google.api.http": { post: "/base.account.MobileAccountService/LoginByPassword", body: "*" } }, I: LoginByPasswordRequest, O: LoginByPasswordResponse },
    { name: "LoginByCaptcha", options: { "google.api.http": { post: "/base.account.MobileAccountService/LoginByCaptcha", body: "*" } }, I: LoginByCaptchaRequest, O: LoginByCaptchaResponse },
    { name: "GetMobileNumberByAccounts", options: { "google.api.http": { post: "/base.account.MobileAccountService/GetMobileNumberByAccounts", body: "*" } }, I: GetMobileNumberByAccountsRequest, O: GetMobileNumberByAccountsResponse },
    { name: "CheckMobileNumberExistence", options: { "google.api.http": { post: "/base.account.MobileAccountService/CheckMobileNumberExistence", body: "*" } }, I: CheckMobileNumberExistenceRequest, O: CheckMobileNumberExistenceResponse },
    { name: "BindingAccountIdForMobileNumber", options: { "google.api.http": { post: "/base.account.MobileAccountService/BindingAccountIdForMobileNumber", body: "*" } }, I: BindingAccountIdForMobileNumberRequest, O: BindingAccountIdForMobileNumberResponse },
    { name: "GetCreationTimestampByAccountIds", options: { "google.api.http": { post: "/base.account.MobileAccountService/GetCreationTimestampByAccountIds", body: "*" } }, I: GetCreationTimestampByAccountIdsRequest, O: GetCreationTimestampByAccountIdsResponse },
    { name: "GetByMobileNumberContains", options: { "google.api.http": { post: "/base.account.MobileAccountService/GetByMobileNumberContains", body: "*" } }, I: GetByMobileNumberContainsRequest, O: GetByMobileNumberContainsResponse },
    { name: "GetByCreateTimestampBetween", options: { "google.api.http": { post: "/base.account.MobileAccountService/GetByCreateTimestampBetween", body: "*" } }, I: GetByCreateTimestampBetweenRequest, O: GetByCreateTimestampBetweenResponse },
    { name: "GetMobileNumberPageByAccounts", options: { "google.api.http": { post: "/base.account.MobileAccountService/GetMobileNumberPageByAccounts", body: "*" } }, I: GetMobileNumberPageByAccountsRequest, O: GetMobileNumberPageByAccountsResponse },
    { name: "GetMobileNumberPageByAppId", options: { "google.api.http": { post: "/base.account.MobileAccountService/GetMobileNumberPageByAppId", body: "*" } }, I: GetMobileNumberPageByAppIdRequest, O: GetMobileNumberPageByAppIdResponse },
    { name: "ResetMobileAccountPassword", options: { "google.api.http": { post: "/base.account.MobileAccountService/ResetMobileAccountPassword", body: "*" } }, I: ResetMobileAccountPasswordRequest, O: ResetPasswordResponse },
    { name: "ResetMobileAccountPasswordByToken", options: { "google.api.http": { post: "/base.account.MobileAccountService/ResetMobileAccountPasswordByToken", body: "*" } }, I: ResetMobileAccountPasswordByTokenRequest, O: ResetPasswordResponse },
    { name: "ResetMobileAccountPasswordByOriginalPassword", options: { "google.api.http": { post: "/base.account.MobileAccountService/ResetMobileAccountPasswordByOriginalPassword", body: "*" } }, I: ResetMobileAccountPasswordByOriginalPasswordRequest, O: ResetPasswordResponse },
    { name: "ActivateAccountByMobileNumberAndCaptcha", options: { "google.api.http": { post: "/base.account.MobileAccountService/ActivateAccountByMobileNumberAndCaptcha", body: "*" } }, I: ActivateAccountByMobileNumberAndCaptchaRequest, O: ActivateAccountByMobileNumberAndCaptchaResponse },
    { name: "CheckPasswordExistByClient", options: { "google.api.http": { post: "/base.account.MobileAccountService/CheckPasswordExistByClient", body: "*" } }, I: CheckPasswordExistByClientRequest, O: CheckPasswordExistByClientResponse }
]);
